import React, { useEffect, useState } from 'react';
import {
  Container,
  Content,
  Title,
  Subtitle,
  Header,
  HeaderGradient,
  HeaderLogo,
  HeaderTitle,
} from './styles';
import { E_LOGO_WHITE } from '../../constants/images';

const REDIRECT_DELAY = 10000;

const GiftCardExpired = () => {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    const redirectTimer = setTimeout(() => {
      window.location.href = '/';
    }, REDIRECT_DELAY);

    return () => {
      clearInterval(countdownInterval);
      clearTimeout(redirectTimer);
    };
  }, []);

  return (
    <Container>
      <Header>
        <HeaderGradient>
          <HeaderLogo src={E_LOGO_WHITE} alt='Eternal Logo' />
          <HeaderTitle>Happy Diwali from all of us at Eternal</HeaderTitle>
        </HeaderGradient>
      </Header>
      <Content>
        <Title>This voucher link has expired</Title>
        <Subtitle>
          The redemption period for this gift card has ended.
        </Subtitle>
        <Subtitle>
          Redirecting to landing page in
          {' '}
          {countdown}
          {' '}
          seconds...
        </Subtitle>
      </Content>
    </Container>
  );
};

export default GiftCardExpired;
